import { z } from 'zod';
export const presignUploadRequestSchema = z.object({
    filename: z.string().min(1).max(200),
    contentType: z
        .string()
        .regex(/^(image|video)\/[\w.+-]+$/, 'Допускаются только image/* и video/*'),
    sizeBytes: z
        .number()
        .int()
        .min(1)
        .max(50 * 1024 * 1024),
});
export const presignUploadResponseSchema = z.object({
    uploadUrl: z.string().url(),
    publicUrl: z.string().url(),
    key: z.string(),
    expiresInSec: z.number().int(),
});
